export const GITHUB_APP_MANIFEST_EDIT_KEY = "githubAppManifestEditKey";
export const GITHUB_APP_PENDING_INSTALLATION = "githubAppPendingInstallationId";
export const GITHUB_APP_INSTALLATION_ERROR = "githubAppInstallationError";

export type GithubAppManifestEditState = {
  core: string;
  policy: string;
  editKey: string;
};
